module.exports = __webpack_public_path__ + "files/f39cd461962a779e79619d6d918cc25d.svg";